import {useEffect, useState, useRef} from 'react';
import classNames from 'classnames';
import {useRouter} from 'next/router';

import Loading from '@components/Loading';

import {useCategory} from '../Context/Category';

const isOpenItem = (collapseItem, lavel, slug, categoryRef) => {
	let open = false;
	if (collapseItem[`cl${lavel}`] === slug) {
		open = true;
	}

	if (categoryRef.current && categoryRef.current[slug]) {
		if (open) {
			categoryRef.current[slug].style.height = 'auto';
		} else {
			if (categoryRef.current[slug].style.height !== '0px') {
				categoryRef.current[slug].style.height =
					categoryRef.current[slug].parentElement.clientHeight + 'px';

				setTimeout(() => {
					categoryRef.current[slug].style.height = '0px';
				}, 1);
			}
		}
	}

	return open;
};

function selectedCategory(slug, categories, data = []) {
	let cat = categories.find(i => i.slug === slug);
	if (cat) {
		data.unshift(cat);
		if (cat.parent_id !== null) {
			let pCat = categories.find(i => i._id === cat.parent_id);
			selectedCategory(pCat?.slug, categories, data);
		}
	}

	return data;
}

function checkedCategory(props) {
	let cl4 = null;
	if (props.filters.category) {
		cl4 = {};
		let category = props.filters.category.split('|');
		for (let i = 0; i < category.length; i++) {
			cl4[category[i]] = true;
		}
	}
	return cl4;
}

function Category(props) {
	return props.isMobile ? <Mobile {...props} /> : <Desktop {...props} />;
}

function Desktop(props) {
	const {styles} = props;
	const {
		categories,
		loading,
		categoryTree,
		filters,
		updateFilter,
		setBreadcrumbs,
		categoryRef,
		expand,
		setExpand,
	} = useCategory();
	const sliderRef = useRef({});
	const [isOpen, setOpen] = useState(props.category ? true : false);
	const router = useRouter();
	const ancestors = selectedCategory(props.category, categories);
	let collapseItem = categories.length
		? {
				cl1: ancestors[0] ? ancestors[0].slug : null,
				cl2: ancestors[1] ? ancestors[1].slug : null,
				cl3: ancestors[2] ? ancestors[2].slug : null,
				cl4: checkedCategory(props),
		  }
		: {};

	useEffect(() => {
		if (categories.length) {
			const selectedCategory = [];
			if (props.category) {
				const slugCat = categories.find(i => i.slug === props.category);
				if (slugCat) {
					selectedCategory.push({
						_id: slugCat.slug,
						label: slugCat.Name,
						parentId: slugCat.parent_id,
						type: 'slug',
					});
				}
			}
			if (props.filters.category) {
				const catSlugs = props.filters.category.split('|');
				const tagCat = categories
					.filter(i => catSlugs.indexOf(i.slug) !== -1)
					.map(i => ({
						_id: i.slug,
						parentId: i.parent_id,
						label: i.Name,
						type: 'category',
					}));

				selectedCategory.push(...tagCat);
			}

			const otherFilter = filters.filter(
				i => i.type !== 'slug' && i.type !== 'category',
			);
			selectedCategory.push(...otherFilter);
			setExpand(collapseItem, 1, true);
			updateFilter(selectedCategory);
			setBreadcrumbs(ancestors);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [categories, props.category, props.filters.category]);

	const handelCollapse = () => {
		if (isOpen) {
			sliderRef.current.style.height =
				sliderRef.current.parentElement.clientHeight + 'px';
			setTimeout(() => {
				sliderRef.current.style.height = '0px';
				setOpen(val => !val);
			}, 10);
		} else {
			sliderRef.current.style.height = 'auto';
			setOpen(val => !val);
		}
	};

	const selectCategory = (category, level, all = false) => {
		if (level !== 4) {
			if (
				level === 1 &&
				!props.filters.name &&
				!props.brand &&
				!props.store &&
				!props.isAuction
			) {
				collapseItem[`cl${level}`] =
					collapseItem[`cl${level}`] === category.slug ? false : category.slug;
				if (category.slug !== props.category) {
					return router.push(`/products/${category.slug}`);
				}
				return false;
			}
			updateFilter(
				[
					{
						_id: category.slug,
						label: category.Name,
						type: 'slug',
					},
				],
				true,
				false,
				all,
			);
		} else {
			let catFilter = filters.filter(
				i => i.type === 'category' || i.type === 'slug',
			);

			const parent = categories.find(item => item._id === category.parent_id);
			const sameParent = catFilter.find(item => item._id === parent.slug);
			if (sameParent) {
				const index = catFilter.findIndex(i => i._id === category.slug);
				if (index !== -1) {
					catFilter.splice(index, 1);
				} else {
					catFilter = [
						...catFilter,
						{
							_id: category.slug,
							label: category.Name,
							type: 'category',
						},
					];
				}
			} else {
				catFilter = [
					{
						_id: parent.slug,
						label: parent.Name,
						type: 'slug',
					},
					{
						_id: category.slug,
						label: category.Name,
						type: 'category',
					},
				];
			}

			updateFilter(catFilter, true);
		}
	};

	const checkedAllTag = slug => {
		return props.category === slug && !props.filters.category;
	};

	return (
		<div className={styles.filterListCard}>
			<div className={styles.cardHeader}>
				<span
					className='card-link'
					data-toggle='collapse'
					aria-expanded={isOpen}
					onClick={() => handelCollapse()}
					style={{}}
				>
					Categories
				</span>
			</div>
			<div
				className={`collapse ${isOpen && 'show'}`}
				ref={sliderRef}
				// style={{height: isOpen ? '320px' : '0px'}}
			>
				<div className={classNames(styles.levelMenu, styles.levelMenuOne)}>
					{loading ? (
						<Loading.ListItem length={5} />
					) : (
						<ul className={styles.levelMenuOne}>
							{categoryTree.map((cl1, i1) => {
								if (collapseItem.cl1 && collapseItem.cl1 !== cl1.slug)
									return null;
								return (
									<li
										key={i1}
										className={`${collapseItem.cl1 ? styles.active : ''}`}
									>
										<span
											aria-expanded={collapseItem.cl1 === cl1.slug}
											onClick={() => selectCategory(cl1, 1)}
										>
											{cl1.Name}{' '}
										</span>
										{!!cl1.children.length && (
											<div
												className={styles.toggleButton}
												data-toggle='collapse'
												aria-expanded={collapseItem.cl1 === cl1.slug}
												onClick={() => setExpand(cl1, 1)}
											>
												<i className='fas fa-chevron-right'></i>
											</div>
										)}
										{!!cl1.children.length && (
											<ul
												className={`collapse level-sub-menu ${
													styles.levelMenuTwo
												} ${
													isOpenItem(expand, 1, cl1.slug, categoryRef) && 'show'
												}`}
												ref={ref => (categoryRef.current[cl1.slug] = ref)}
											>
												{cl1.children.map((cl2, i2) => (
													<li key={i2}>
														<span
															aria-expanded={isOpenItem(
																expand,
																2,
																cl2.slug,
																categoryRef,
															)}
															onClick={() => selectCategory(cl2, 2)}
														>
															{cl2.Name}{' '}
														</span>
														{!!cl2.children.length && (
															<div
																className={styles.toggleButton}
																data-toggle='collapse'
																aria-expanded={isOpenItem(
																	expand,
																	2,
																	cl2.slug,
																	categoryRef,
																)}
																onClick={() => setExpand(cl2, 2)}
															>
																<i className='fas fa-chevron-right'></i>
															</div>
														)}
														{!!cl2.children.length && (
															<ul
																className={`collapse level-sub-menu ${
																	styles.levelMenuTwo
																} ${
																	isOpenItem(
																		expand,
																		2,
																		cl2.slug,
																		categoryRef,
																	) && 'show'
																}`}
																ref={ref =>
																	(categoryRef.current[cl2.slug] = ref)
																}
															>
																{cl2.children.map((cl3, i3) => (
																	<li key={i3}>
																		<span
																			aria-expanded={isOpenItem(
																				expand,
																				3,
																				cl3.slug,
																				categoryRef,
																			)}
																			onClick={() => selectCategory(cl3, 3)}
																		>
																			{cl3.Name}{' '}
																		</span>
																		{!!cl3.children.length && (
																			<div
																				data-toggle='collapse'
																				aria-expanded={isOpenItem(
																					expand,
																					3,
																					cl3.slug,
																					categoryRef,
																				)}
																				className={styles.toggleButton}
																				onClick={() => setExpand(cl3, 3)}
																			>
																				<i className='fas fa-chevron-right'></i>
																			</div>
																		)}
																		{!!cl3.children.length && (
																			<ul
																				className={`collapse level-sub-menu ${
																					styles.levelMenuThree
																				} ${
																					isOpenItem(
																						expand,
																						3,
																						cl3.slug,
																						categoryRef,
																					) && 'show'
																				}`}
																				ref={ref =>
																					(categoryRef.current[cl3.slug] = ref)
																				}
																			>
																				<li>
																					<label className='custom-check'>
																						{`All ${cl3.Name}`}
																						<input
																							type='checkbox'
																							checked={checkedAllTag(cl3.slug)}
																							onChange={() =>
																								selectCategory(cl3, 3, true)
																							}
																						/>
																						<i className='checkmark'></i>
																					</label>
																				</li>
																				{cl3.children.map((cl4, i4) => (
																					<li key={i4}>
																						<label className='custom-check'>
																							{cl4.Name}
																							<input
																								type='checkbox'
																								checked={
																									collapseItem.cl4 &&
																									collapseItem.cl4[cl4.slug]
																										? true
																										: false
																								}
																								onChange={() =>
																									selectCategory(cl4, 4)
																								}
																							/>
																							<i className='checkmark'></i>
																						</label>
																					</li>
																				))}
																			</ul>
																		)}
																	</li>
																))}
															</ul>
														)}
													</li>
												))}
											</ul>
										)}
									</li>
								);
							})}
						</ul>
					)}
				</div>
			</div>
		</div>
	);
}

function Mobile(props) {
	const {styles} = props;
	const {categories, loading, categoryTree} = useCategory();
	const ancestors = selectedCategory(props.category, categories);
	let item = categories.length
		? {
				cl1: ancestors[0] ? ancestors[0].slug : null,
				cl2: ancestors[1] ? ancestors[1].slug : null,
				cl3: ancestors[2] ? ancestors[2].slug : null,
				cl4: checkedCategory({filters: props.params}),
		  }
		: {};

	const [collapseItem, setCollapseItem] = useState(item);

	const showParent = (category, collapse) => {
		if (
			!props.filters.name &&
			!props.brand &&
			!props.store &&
			!props.isAuction
		) {
			return category.slug;
		}
		return category.slug === collapse.cl1 ? null : category.slug;
	};

	const selectCategory = (category, level) => {
		let collapse = {...collapseItem};

		switch (level) {
			case 1:
				collapse = {
					...collapse,
					cl1: showParent(category, collapse),
					cl2: null,
					cl3: null,
					cl4: null,
				};
				break;
			case 2:
				collapse = {
					...collapse,
					cl2: category.slug === collapse.cl2 ? null : category.slug,
					cl3: null,
					cl4: null,
				};
				break;
			case 3:
				collapse = {
					...collapse,
					cl3: category.slug,
					cl4: null,
				};
				break;
			case 4: {
				let cl4 = collapse.cl4 || {};
				if (cl4[category.slug]) {
					delete cl4[category.slug];
				} else {
					cl4[category.slug] = true;
				}
				collapse = {
					...collapse,
					cl4: cl4 && Object.keys(cl4).length ? cl4 : null,
				};
				break;
			}
			default:
				break;
		}

		props.setFilter(collapse);
		setCollapseItem(collapse);
	};

	const checkedAllTag = slug => {
		return collapseItem.cl3 === slug && !collapseItem.cl4;
	};

	return (
		<div className={styles.filterListCard}>
			<div className={`collapse show`}>
				<div className={classNames(styles.levelMenu, styles.levelMenuOne)}>
					{loading ? (
						<Loading.ListItem length={5} />
					) : (
						<ul>
							{categoryTree.map((cl1, i1) => {
								if (collapseItem.cl1 && collapseItem.cl1 !== cl1.slug)
									return null;
								return (
									<li
										key={i1}
										className={`${collapseItem.cl1 ? styles.active : ''}`}
									>
										<span
											aria-expanded={collapseItem.cl1 === cl1.slug}
											onClick={() => selectCategory(cl1, 1)}
										>
											{cl1.Name}{' '}
											{!!cl1.children.length && (
												<i className='fas fa-chevron-right'></i>
											)}
										</span>
										{!!cl1.children.length && (
											<ul
												className={`collapse level-sub-menu ${
													styles.levelMenuTwo
												} ${collapseItem.cl1 === cl1.slug && 'show'}`}
											>
												{cl1.children.map((cl2, i2) => (
													<li key={i2}>
														<span
															data-toggle='collapse'
															aria-expanded={collapseItem.cl2 === cl2.slug}
															onClick={() => selectCategory(cl2, 2)}
														>
															{cl2.Name}{' '}
															{!!cl2.children.length && (
																<i className='fas fa-chevron-right'></i>
															)}
														</span>
														{!!cl2.children.length && (
															<ul
																className={`collapse level-sub-menu ${
																	styles.levelMenuTwo
																} ${collapseItem.cl2 === cl2.slug && 'show'}`}
															>
																{cl2.children.map((cl3, i3) => (
																	<li key={i3}>
																		<span
																			data-toggle='collapse'
																			aria-expanded={
																				collapseItem.cl3 === cl3.slug
																			}
																			onClick={() => selectCategory(cl3, 3)}
																		>
																			{cl3.Name}{' '}
																			{!!cl3.children.length && (
																				<i className='fas fa-chevron-right'></i>
																			)}
																		</span>
																		{!!cl3.children.length && (
																			<ul
																				className={`collapse level-sub-menu ${
																					styles.levelMenuThree
																				} ${
																					collapseItem.cl3 === cl3.slug &&
																					'show'
																				}`}
																			>
																				<li>
																					<label className='custom-check'>
																						{`All ${cl3.Name}`}
																						<input
																							type='checkbox'
																							checked={checkedAllTag(
																								cl3.slug,
																								cl3.children,
																							)}
																							onChange={() =>
																								selectCategory(cl3, 3, true)
																							}
																						/>
																						<i className='checkmark'></i>
																					</label>
																				</li>
																				{cl3.children.map((cl4, i4) => (
																					<li key={i4}>
																						<label className='custom-check'>
																							{cl4.Name}
																							<input
																								type='checkbox'
																								checked={
																									collapseItem.cl4 &&
																									collapseItem.cl4[cl4.slug]
																										? true
																										: false
																								}
																								onChange={() =>
																									selectCategory(cl4, 4)
																								}
																							/>
																							<i className='checkmark'></i>
																						</label>
																					</li>
																				))}
																			</ul>
																		)}
																	</li>
																))}
															</ul>
														)}
													</li>
												))}
											</ul>
										)}
									</li>
								);
							})}
						</ul>
					)}
				</div>
			</div>
		</div>
	);
}

export default Category;
